import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import CheckoutProgressHero from "../checkout-progress-hero";
import MembershipCTA from "../membership-cta";
import { gearOrderDetails } from "../../utils/processesOrderDetails";

import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction } from "../../redux/actions/gears-checkout";
import { selectUserState } from "../../selectors/application";
import { isMemberSelector } from "../../selectors/gears-checkout";

const ContactField = ({ className, title, lines }) => {
  return (
    <div className={className}>
      <h4 className="type-h4">{title}</h4>
      <ul>
        {lines.map((line, index) => {
          return (
            <li key={index}>
              <p className="light-gray">{line}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const CheckoutOnlineconfirmation = ({ fields, lang, rendering, history, isMember, user, clearBillingInfo, clearShippingInfo, clearContactInfo, orderId, queryInStore, hero }) => {
  const { headingBody, body, orderNoLabel, itemsTitle, orderFields, shippingAdressHeading, contactInfoHeading, membershipHeading, perksHTML, membershipButton, linksTitle, linksHTML } = fields;
  const [itemList, setItemList] = useState([]);
  const [contentRows, setContentRows] = useState([]);
  const [shippingAdressLine, setShippingAdressLine] = useState([]);
  const [contactInfoLine, setContactInfoLine] = useState([]);
  const [orderDetailValue, setOrderDetailValue] = useState([]);

  useEffect(() => {
    getOrder();
  }, []);
  const getOrder = async () => {
    clearBillingInfo();
    clearShippingInfo();
    clearContactInfo();
    const { itemList, shippingAdressLineValue, contactInfoLineValue, _orderData, orderDetail } = await gearOrderDetails({
      orderId: orderId,
      orderFields: orderFields,
      lang: lang,
      inStore: queryInStore
    });
    setOrderDetailValue(orderDetail)
    setItemList(itemList);
    setShippingAdressLine(shippingAdressLineValue);
    setContactInfoLine(contactInfoLineValue);
    setContentRows(_orderData);
  };

  const membershipInfo = {
    user,
    isMember,
    queryInStore,
    heading: membershipHeading.value,
    perksHTML: perksHTML.value,
    button: {
      ...membershipButton?.fields,
      link: {
        value: {
          ...membershipButton?.fields.link?.value,
          href: membershipButton?.fields.link?.value?.href ? `${membershipButton.fields.link.value.href}?orderNo=${orderDetailValue?.orderNo}&orderId=${orderId}` : `/${lang}`
        }
      }
    },
    linksTitle: linksTitle.value,
    linksHTML: linksHTML.value
  };
  let shippingAdress = {
    title: shippingAdressHeading.value,
    lines: shippingAdressLine
  };
  let contactInfo = {
    title: contactInfoHeading.value,
    lines: contactInfoLine
  };
  return (
    <div className="checkout-order-confirmation" datasourceid={rendering.dataSource}>
      <CheckoutProgressHero {...hero} />
      <div className="summary-container grid">
        <div className="summary-heading">
          <h3 className="type-h3">{headingBody.value}</h3>
          <p className="body-small">{body.value}</p>
        </div>
        <div className="summary-list">
          <ul>
            <li className="content-row" key={orderNoLabel.value}>
              <h4 className="type-h4">{orderNoLabel.value + orderDetailValue?.orderNo}</h4>
            </li>
            <li className="content-row split">
              <p>{itemsTitle.value}</p>
              <ul>
                {itemList.map((item, index) => {
                  return (
                    <li key={index}>
                      <span className="darker-light-gray">[</span>
                      <p className="item-count">{item.quantity}</p>
                      <span className="darker-light-gray">]</span>
                      <p className="item-name">{item.name}</p>
                    </li>
                  );
                })}
              </ul>
            </li>
            {contentRows.map((row, index) => {
              return (
                <li className="content-row split" key={index}>
                  <p className="darker-light-gray">{row.title}</p>
                  <p>{row.value}</p>
                </li>
              );
            })}
          </ul>
        </div>
        {shippingAdressLine.length > 0 && <ContactField {...shippingAdress} className="info shipping-adress" />}
        {contactInfoLine.length > 0 && <ContactField {...contactInfo} className="info contact-info" />}
        <MembershipCTA {...membershipInfo} />
      </div>
    </div>
  );
};
const mapDispatchToProps = dispatch => ({
  clearBillingInfo: () => dispatch(clearBillingInfoAction()),
  clearShippingInfo: () => dispatch(clearShippingInfoAction()),
  clearContactInfo: () => dispatch(clearContactInfoAction())
});
const mapStateToProps = state => ({
  user: selectUserState(state),
  isMember: isMemberSelector(state)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckoutOnlineconfirmation));
